export function normalizePhoneForWhatsapp(phone = '') {
  return String(phone).replace(/[^\d]/g, '');
}

export function buildWhatsappLink(phone, message) {
  const normalized = normalizePhoneForWhatsapp(phone);
  const text = encodeURIComponent(message || 'Hello, I am interested in a travel package.');
  return `https://wa.me/${normalized}?text=${text}`;
}

